import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

import { defineComponent } from 'vue'

type Integration = {
  name: string
  icon: string
  description: string
}



export default /*@__PURE__*/_defineComponent({
  __name: 'Integrations',
  setup(__props) {

const collaborations: Integration[] = [
  {
    name: 'WhatsApp Business API',
    icon: 'mdi-whatsapp',
    description: 'Conecta tu WhatsApp empresarial.',
  },
  {
    name: 'Instagram API',
    icon: 'mdi-instagram',
    description: 'Gestiona mensajes de Instagram.',
  },
  {
    name: 'Facebook API',
    icon: 'mdi-facebook',
    description: 'Administra Facebook Messenger.',
  },
  {
    name: 'Gmail',
    icon: 'mdi-gmail',
    description: 'Envía y recibe correos de Gmail.',
  },
  {
    name: 'Google Meet',
    icon: 'mdi-video',
    description: 'Agrega videollamadas Meet.',
  },
  {
    name: 'ChatGPT',
    icon: 'mdi-robot-outline',
    description: 'Automatiza respuestas con IA.',
  },
]


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "px-md-12" }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "mb-4 px-4 px-md-0" }, "Integraciones", -1)),
      _createVNode(_component_v_row, { class: "mx-0 my-3" }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(collaborations, (collaboration, index) => {
            return _createVNode(_component_v_col, {
              cols: "12",
              md: "3",
              key: index
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "pa-6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "ma-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(collaboration.icon), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_title, { class: "px-0" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(collaboration.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          disabled: "",
                          size: "x-small",
                          variant: "outlined"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createTextVNode("mdi-plus")
                              ])),
                              _: 1,
                              __: [0]
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_card_subtitle, { class: "pa-0" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(collaboration.description), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      })
    ]),
    _: 1,
    __: [1]
  }))
}
}

})